import { render, staticRenderFns } from "./UtilityPeriodTotal.vue?vue&type=template&id=08b7a7ab&scoped=true&"
import script from "./UtilityPeriodTotal.vue?vue&type=script&lang=ts&"
export * from "./UtilityPeriodTotal.vue?vue&type=script&lang=ts&"
import style0 from "./UtilityPeriodTotal.vue?vue&type=style&index=0&id=08b7a7ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7a7ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
